import React, { useState, useContext, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { isUserNurseAideRoleGroup } from '@mummssoftware/utils/utils';
import { handleNumericChange } from '@mummssoftware/utils/visitUtils';
import { VisitContext } from '../Context/contexts/VisitContext';
import { EditVisitDiv } from '../../components';
import { Context } from '../../context';
import {
  SCIPU,
  SET_TRAVEL_TIME,
  SET_TRANSIT_FEES,
  SET_TOLLS_FEES,
  SET_MILEAGE,
} from '../Context/constants';
import CCTimer from '../Timer/CCTimer';

import defaults from '../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  input: {
    padding: '8px',
    fontSize: '1rem',
  },
  label: {
    fontSize: '1rem',
  },
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    width: '95px',
    marginTop: '15px',
    flexDirection: 'row',
    marginBottom: '0px',
  },
}));

export const Fees = () => {
  const classes = useStyles();
  const {
    dispatchVisit,
    IPUVisit,
    travelMileage: ctxTravelMileage,
    transitFees: ctxTransitFees,
    travelDuration: ctxTravelDuration,
    tollsFee: ctxTollsFee,
  } = useContext(VisitContext);
  const { appVisit } = useContext(GlobalContext);
  const { currentUser } = useContext(Context);
  const isCCRoleGroup = isUserNurseAideRoleGroup(currentUser);

  const [transitFee, setTransitFee] = useState<number>(0);
  const [mileage, setMileage] = useState<number>(0);
  const [travelTime, setTravelTime] = useState<number>(0);
  const [tollsFee, setTollsFee] = useState<number>(0);

  useEffect(() => {
    setMileage(ctxTravelMileage ?? 0);
    setTravelTime(ctxTravelDuration ?? 0);
    setTollsFee(ctxTollsFee ?? 0);
    setTransitFee(ctxTransitFees ?? 0);
  }, [ctxTravelMileage, ctxTravelDuration, ctxTollsFee, ctxTransitFees]);

  const onTransitFeeChange = handleNumericChange(
    setTransitFee,
    SET_TRANSIT_FEES,
    dispatchVisit,
  );
  const onMileageChange = handleNumericChange(
    setMileage,
    SET_MILEAGE,
    dispatchVisit,
  );
  const onTravelTimeChange = handleNumericChange(
    setTravelTime,
    SET_TRAVEL_TIME,
    dispatchVisit,
  );
  const onTollFeeChange = handleNumericChange(
    setTollsFee,
    SET_TOLLS_FEES,
    dispatchVisit,
  );

  return (
    <EditVisitDiv id="edit-fees">
      {(!IPUVisit || appVisit?.source === SCIPU) && (
        <CCTimer isCCRoleGroup={isCCRoleGroup} />
      )}
      <TextField
        label="Mileage"
        id="mileage"
        value={mileage}
        className={clsx(classes.margin, classes.textField)}
        InputProps={{
          startAdornment: <InputAdornment position="start">mi</InputAdornment>,
          classes: { input: classes.input },
        }}
        InputLabelProps={{
          classes: {
            formControl: classes.label,
          },
        }}
        variant="outlined"
        onChange={onMileageChange}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{ maxLength: 5 }}
      />
      <TextField
        label="Travel Time"
        id="travel-time"
        value={travelTime}
        className={clsx(classes.margin, classes.textField)}
        InputProps={{
          startAdornment: <InputAdornment position="start">min</InputAdornment>,
          classes: { input: classes.input },
        }}
        InputLabelProps={{
          classes: {
            formControl: classes.label,
          },
        }}
        variant="outlined"
        onChange={onTravelTimeChange}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{ maxLength: 5 }}
      />
      <TextField
        label="Tolls Fees"
        id="tolls-fees"
        value={tollsFee}
        className={clsx(classes.margin, classes.textField)}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
          classes: { input: classes.input },
        }}
        InputLabelProps={{
          classes: {
            formControl: classes.label,
          },
        }}
        variant="outlined"
        onChange={onTollFeeChange}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{ maxLength: 5 }}
      />
      <TextField
        label="Transit Fees"
        id="transit-fees"
        value={transitFee}
        className={clsx(classes.margin, classes.textField)}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
          classes: { input: classes.input },
        }}
        InputLabelProps={{
          classes: {
            formControl: classes.label,
          },
        }}
        variant="outlined"
        onChange={onTransitFeeChange}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{ maxLength: 5 }}
      />
    </EditVisitDiv>
  );
};

export default Fees;
